




import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SaveButton extends Vue {
  @Prop({ type: Boolean, default: false })
  public disabled!: boolean

  @Prop({ type: Boolean, default: false })
  public pending!: boolean

  @Emit()
  public click() {}
}
